import { isEmpty } from '../../utils';
import ValidationResult from '../ValidationResult';
import { $l } from '../../locale-context';
export default function tooShort(value, validatorBaseProps, getProp) {
    if (!isEmpty(value)) {
        const minLength = getProp('minLength');
        if (minLength !== undefined && minLength > 0) {
            const { length } = value.toString();
            if (length < minLength) {
                const injectionOptions = { minLength, length };
                const ruleName = 'tooShort';
                const { [ruleName]: validationMessage = $l('Validator', 'too_short'), } = getProp('defaultValidationMessages') || {};
                return new ValidationResult({
                    validationProps: {
                        ...validatorBaseProps,
                        minLength,
                    },
                    validationMessage,
                    injectionOptions,
                    value,
                    ruleName,
                });
            }
        }
    }
    return true;
}
